import { LoggerService } from './../../logger/logger.service';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SharedService } from '../../shared/shared.service';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AbstractControl } from '@angular/forms';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { GlobalVariable } from '../../shared/global';
import { stringify } from 'querystring';


const MOBILE_REGEX = /^\d{10}$/;
// tslint:disable-next-line:max-line-length
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {

  passwordFormControl = new FormControl('', [Validators.required]);
  usernameFormControl = new FormControl('', [Validators.required]);

  sign_in_valid: boolean;
  public mobile: string;
  public password: string;
  public keep_me_signed_in: boolean;
  public sign_in_type: string;
  public sign_in_data: Object;
  public component_load: boolean;
  public is_account_setting: boolean;
  public is_internal_user: boolean;
  public userNameForm;
  public username: any;
  public readonly_cls: string;
  public signin_text: any;
  public is_error: boolean;
  public error_msg: string = "";

  constructor(private meta: Meta, private title: Title, private fb: FormBuilder, private activatedRoute: ActivatedRoute,
    private sharedService: SharedService, private authService: AuthService, private logger:LoggerService,
    private router: Router, private localStorageService: LocalStorageService) {

    this.addUpdateMetaTags();

    this.userNameForm = fb.group({
      mobilePhoneFormControl: ['', Validators.required]
    }, { validator: UserNameValidation.UserNameValidate });
    this.sharedService.setHeaderTitle('default_page');
    this.readonly_cls = '';
    this.signin_text = 'Sign In';
    let methodName = this.constructor.name+'.verifyToken';
    if (this.localStorageService.get('token') != null && this.localStorageService.get('agentToken') === null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then(res => {
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
          if (res.status === 'success' && res.isTerminated === false) {
            this.activatedRoute.params.subscribe((params: Params) => {
              this.sign_in_type = params['sign_in_type'];
              if (this.sign_in_type !== undefined && this.sign_in_type === 'AccountSetting') {
                const that = this.sharedService;
                const context = this;
                setTimeout(function () {
                  context.is_error = false;
                  that.setHeaderTitle('sign_in');
                }, 10);
                const person = res.results[0]['personal'];

                var dataLayerEvent = 'sign in';
                (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': person[0].id.toString() });

                this.sharedService.setHeaderUserLoggedIn('sign_in', true, person[0]);
                this.component_load = true;
                this.sign_in_valid = false;
                this.mobile = person[0].username;
                this.password = '';
                this.username = '';
                this.keep_me_signed_in = true;
                this.is_account_setting = true;
                this.readonly_cls = 'readonly-input';
              } else if (this.sign_in_type !== undefined && this.sign_in_type === 'reward') {
                this.getRewardDetail(res['results'][0]['personal'][0]);
              }
              else {
                if (this.localStorageService.get('returnUrl') != null) {
                  this.router.navigate(['./' + this.localStorageService.get('returnUrl')]);
                  this.localStorageService.remove('returnUrl');
                } else {
                  this.router.navigate(['./dashboard']);
                }
              }
            });
          } else {
            this.activatedRoute.params.subscribe((params: Params) => {
              this.sign_in_type = params['sign_in_type'];
              if (this.sign_in_type === undefined) {
                this.localStorageService.remove('token');
                this.localStorageService.remove('tempToken');
                // this.sharedService.setHeaderTitle("sign_in");
                const that = this.sharedService;
                const context = this;
                setTimeout(function () {
                  context.is_error = false;
                  that.setHeaderTitle('sign_in');
                }, 10);
                this.sharedService.setHeaderUserLoggedIn('sign_in', false, {});
                this.component_load = true;
                this.sign_in_valid = false;
                this.mobile = '';
                this.password = '';
                this.username = '';
                this.keep_me_signed_in = true;
              } else {
                this.router.navigate(['./sign-in']);
              }
            });
          }
        }, (error)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: ex
          };
          this.logger.logError(JSON.stringify(logObj));
        });
    } else {
      if (this.localStorageService.get('agentToken') !== null) {
        this.localStorageService.remove('agentToken');
      }
      if (this.localStorageService.get('token') !== null) {
        this.localStorageService.remove('token');
      }
      this.activatedRoute.params.subscribe((params: Params) => {
        this.sign_in_type = params['sign_in_type'];
        if (this.sign_in_type === undefined) {
          // this.sharedService.setHeaderTitle("sign_in");
          const that = this.sharedService;
          const context = this;
          setTimeout(function () {
            context.is_error = false;
            that.setHeaderTitle('sign_in');
          }, 10);
          this.component_load = true;
          this.sign_in_valid = false;
          this.mobile = '';
          this.password = '';
          this.keep_me_signed_in = true;
        } else if (this.sign_in_type !== undefined && this.sign_in_type === 'internal-user') {
          let methodName = this.constructor.name+'.verifyToken';
          if (this.localStorageService.get('agentToken') != null) {
            this.sharedService.verifyToken({ 'token': this.localStorageService.get('agentToken'), 'isAgent': true })
              .then(res => {
                let logObj = {
                  method: methodName,
                  request: "token : [masked]",
                  response: res
                };
                this.logger.logInfo(JSON.stringify(logObj));
                if (res.status === 'success') {

                  this.router.navigate(['./internal-user/dashboard']);
                } else {
                  this.localStorageService.remove('agentToken');
                  this.router.navigate(['./internal-user/sign-in']);
                }
              }, (error)=>{
                let logObj = {
                  method: methodName,
                  request: "token : [masked]",
                  exception: error
                };
                this.logger.logError(JSON.stringify(logObj));
              }).catch((ex)=>{
                let logObj = {
                  method: methodName,
                  request: "token : [masked]",
                  exception: ex
                };
                this.logger.logError(JSON.stringify(logObj));
              });
          } else {
            const that = this.sharedService;
            const context = this;
            setTimeout(function () {
              context.is_error = false;
              that.setHeaderTitle('sign_in_agent');
            }, 10);
            this.component_load = true;
            this.sign_in_valid = false;
            this.mobile = '';
            this.password = '';
            this.keep_me_signed_in = true;
            this.is_internal_user = true;
          }
        } else if (this.sign_in_type !== undefined && this.sign_in_type === 'payment') {
          this.localStorageService.remove('token');
          const that = this.sharedService;
          const context = this;
          setTimeout(function () {
            context.is_error = false;
            that.setHeaderTitle('sign_in');
          }, 10);
          this.sharedService.setHeaderUserLoggedIn('sign_in', false, {});
          this.component_load = true;
          this.sign_in_valid = false;
          this.mobile = '';
          this.password = '';
          this.username = '';
          this.keep_me_signed_in = true;
        } else if (this.sign_in_type !== undefined && this.sign_in_type === 'reward') {
          this.localStorageService.remove('token');
          const that = this.sharedService;
          const context = this;
          setTimeout(function () {
            context.is_error = false;
            that.setHeaderTitle('sign_in');
          }, 10);
          this.sharedService.setHeaderUserLoggedIn('sign_in', false, {});
          this.component_load = true;
          this.sign_in_valid = false;
          this.mobile = '';
          this.password = '';
          this.username = '';
          this.keep_me_signed_in = true;
        } else {
          this.router.navigate(['./sign-in']);
        }
      });
    }
  }

  addUpdateMetaTags() {
    this.title.setTitle('My Account | Pogo Energy');
    const titleTag = this.meta.getTag('name=title');

    if (titleTag != undefined) {
      this.meta.updateTag({ name: 'title', content: 'My Account | Pogo Energy' });
    } else {
      this.meta.addTag({ name: 'title', content: 'My Account | Pogo Energy' });
    }

    const descriptionTag = this.meta.getTag('name=description');

    if (descriptionTag != undefined) {
      this.meta.updateTag({ name: 'description', content: 'Sign in to your Pogo Energy account to view history, recharge and manage your contact info.' });
    } else {
      this.meta.addTag({ name: 'description', content: 'Sign in to your Pogo Energy account to view history, recharge and manage your contact info.' });
    }
  }

  ngOnDestroy() {
    this.title.setTitle('Pogo Energy');
    const titleTag = this.meta.getTag('name=title');

    if (titleTag != undefined) {
      this.meta.updateTag({ name: 'title', content: 'Pogo Energy' });
    }

    const descriptionTag = this.meta.getTag('name=description');

    if (descriptionTag != undefined) {
      this.meta.updateTag({ name: 'description', content: '' });
    }
  }

  signInValidate(sign_in_val: any) {
    if (this.sign_in_type === 'internal-user') {
      if (this.username !== undefined && this.username !== '' && this.password !== undefined &&
        this.password !== '' && this.password.length > 5) {
        this.sign_in_valid = true;
        if (sign_in_val.keyCode === 13) {
          document.getElementById('sign_in_btn').click();
        }
      } else {
        this.sign_in_valid = false;
      }
    } else {
      if (this.mobile !== '' && this.mobile !== undefined) {
        let username = this.mobile;
        if (!username.includes("@")) {
          username = username.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, "");
        }
        if ((username.match(MOBILE_REGEX) || username.match(EMAIL_REGEX)) && this.password !== undefined && this.password !== '' && this.password.length > 5) {
          this.sign_in_valid = true;
          if (sign_in_val.keyCode === 13) {
            document.getElementById('sign_in_btn').click();
          }
        } else {
          this.sign_in_valid = false;
        }
      } else {
        this.sign_in_valid = false;
      }
    }
  }

  signIn() {
	this.localStorageService.set('is_express_pay', false);
    this.signin_text = 'Sign In...';
    this.sign_in_valid = false;
    if (this.sign_in_type === undefined) {
      this.is_error = false;
      let username = this.mobile;
      if (!username.includes("@")) {
        username = username.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, "");
      }
      this.sign_in_data = {
        'username': username,
        'password': this.password,
        'keepMeSignedIn': this.keep_me_signed_in,
        'isAmberUILogin':true
      }
    } else if (this.sign_in_type === 'internal-user') {
      this.is_error = false;
      this.sign_in_data = {
        'username': this.username,
        'password': this.password,
        'keepMeSignedIn': this.keep_me_signed_in,
        'isAgent': true,
        'isAmberUILogin':true
      }
    } else if (this.sign_in_type === 'payment') {
      this.is_error = false;
      let username = this.mobile;
      if (!username.includes("@")) {
        username = username.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, "");
      }
      this.sign_in_data = {
        'username': username,
        'password': this.password,
        'keepMeSignedIn': this.keep_me_signed_in,
        'isAmberUILogin':true
      };
    } else if (this.sign_in_type === 'reward') {
      this.is_error = false;
      let username = this.mobile;
      if (!username.includes("@")) {
        username = username.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, "");
      }
      this.sign_in_data = {
        'username': username,
        'password': this.password,
        'keepMeSignedIn': this.keep_me_signed_in,
        'isAmberUILogin':true
      };
    } else {
      this.is_error = false;
      this.sign_in_data = {
        'password': this.password,
        'typeSetting': true,
        'username': this.mobile,
        'isAmberUILogin':true
      }
    }

    let methodName = this.constructor.name+'.signIn';

    this.authService.signIn(this.sign_in_data).then(res => {
      this.sign_in_data['password'] = "[masked]";
      let logObj = {
        method: methodName,
        request: this.sign_in_data,
        response: res
      };
      this.logger.logInfo(JSON.stringify(logObj));

      if (res.status === 'success') {
		  this.localStorageService.remove('email');
		  this.localStorageService.remove('mobile_phone');
		  this.localStorageService.remove('account_number');
		  this.localStorageService.remove('used_mobile_no');
		  this.localStorageService.remove('used_email');
        if (this.sign_in_type === 'internal-user') {
          this.localStorageService.set('agentToken', res.token);
          this.localStorageService.set('isSuperAdmin', res.isSuperAdmin);
          this.router.navigate(['./internal-user/dashboard']);
        } else if (this.sign_in_type === 'payment') {
          this.localStorageService.set('token', res.token);
          this.router.navigate(['./make-payment']);
        } else if (this.sign_in_type === 'reward') {
          this.localStorageService.set('token', res.token);
          this.getRewardDetail(res['results'][0]['personal'][0]);
        } else {
          if (res.isAccountSetting) {
            this.router.navigate(['./Profile/AccountSetting']);
          } else {
            if (res.accountStatusMap!== null) {
              // if (res.accountStatusMap['cansignin']==0) {
                this.sharedService.setHeaderUserLoggedIn('dashboard', true, res.results[0]['personal'][0]);
                const person = res.results[0]['personal'][0];

                var dataLayerEvent = 'sign in';
                (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': person.id.toString() });

                this.localStorageService.set('token', res.token);
                this.is_error = false;
                if (this.localStorageService.get('returnUrl') != null) {
                  this.router.navigate(['./' + this.localStorageService.get('returnUrl')]);
                  this.localStorageService.remove('returnUrl');
                } else {
                  this.router.navigate(['./dashboard']);
                }
              // } else {
              //   this.error_msg = res.accountStatusMap['display'];
              //   this.is_error = true;
              // }
            } else {
              this.sharedService.setHeaderUserLoggedIn('dashboard', true, res.results[0]['personal'][0]);
              const person = res.results[0]['personal'][0];

			  this.localStorageService.set('name', person.firstName + ' ' + person.lastName);
			  this.localStorageService.set('billingAccountNumber', person.accountNumber);

              var dataLayerEvent = 'sign in';
              (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': person.id.toString() });

              this.localStorageService.set('token', res.token);
              this.is_error = false;
              if (this.localStorageService.get('returnUrl') != null) {
                this.router.navigate(['./' + this.localStorageService.get('returnUrl')]);
                this.localStorageService.remove('returnUrl');
              } else {
                this.router.navigate(['./dashboard']);
              }
            }
          }
        }
      } else if (res.status === 'fail') {
        this.signin_text = 'Sign In';
        this.sign_in_valid = true;
        this.error_msg = res.message;
        this.is_error = true;
      }
    }, (error)=>{
      let logObj = {
        method: methodName,
        request: this.sign_in_data,
        exception: error
      };
      this.logger.logError(JSON.stringify(logObj));
    }).catch((ex)=>{
      let logObj = {
        method: methodName,
        request: this.sign_in_data,
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
    });
  }

  ngOnInit() {
    const len = document.getElementsByTagName('body')[0];
    if (len !== undefined) {
      if (len.classList.contains('body_autocomplete')) {
        len.classList.remove('body_autocomplete');
      }
    }
  }

  enrollForReward(person_details: any) {
    let methodName = this.constructor.name+'.enrollForReward';
    this.sharedService.getUserConfig('reward_amount')
      .then(res => {
        let logObj = {
          method: methodName,
          request: '',
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        if (res !== undefined && res.result.status === "success") {
          let conf_data = res.result.config[0];
          this.sharedService.enrollToRewardProgram(person_details, conf_data.value)
            .then(res => {
              if (res != undefined && res.result == "success") {
                this.getRewardDetail(person_details['account_number']);
              }
            });
        }
      }, (error)=>{
        let logObj = {
          method: methodName,
          request: '',
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex)=>{
        let logObj = {
          method: methodName,
          request: '',
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }

  getRewardDetail(person_details: any) {
    let methodName = this.constructor.name+'.enrollForReward';
    let requestObj = {
      "method": "get_token",
      "customer_id": person_details['accountNumber'],
      "key": GlobalVariable.rewardsApiKey
    };

    this.sharedService.rewardAPICall(requestObj)
      .then(res => {
        requestObj.key = "[masked]";
        let logObj = {
          method: methodName,
          request: requestObj,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        if (res != undefined && res.result == "success") {
          window.open(GlobalVariable.rewardsUrl + "login/login_by_stream/" + res.token, "_self");
        } else {
          this.enrollForReward(person_details);
        }
      }, (error)=>{
        requestObj.key = "[masked]";
        let logObj = {
          method: methodName,
          request: requestObj,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex)=>{
        requestObj.key = "[masked]";
        let logObj = {
          method: methodName,
          request: requestObj,
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }

}

export class UserNameValidation {

  static UserNameValidate(AC: AbstractControl) {
    let username:string = AC.get('mobilePhoneFormControl').value; // to get value in input tag
    if (!username.includes("@")) {
      username = username.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, "");
    }
    if (username !== '' && !username.match(MOBILE_REGEX) && !username.match(EMAIL_REGEX)) {
      AC.get('mobilePhoneFormControl').setErrors({ UserNameValidate: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/sign-in/sign-in.component.ts